import { ProjectMemberDto, TenantUserDto } from '../api/model';
import { userDisplayName } from '../hooks/useTenantUsers';
import { memberAsUser } from './projectMembers';

/**
 * The person picked as a deliverable's responsible, or undefined. It is
 * optional and open-ended - there is no default standing in for nobody.
 */
export function deliverableResponsible(
  responsibleUserId: number | undefined | null,
  members: ProjectMemberDto[] | undefined,
): TenantUserDto | undefined {
  if (responsibleUserId == null) return undefined;
  const member = (members ?? []).find((m) => m.userId === responsibleUserId);
  // Not in the member list (yet): still picked, shown by id until the list loads.
  return member ? memberAsUser(member) : { id: responsibleUserId };
}

export function userInitials(user: TenantUserDto): string {
  const combined = `${user.firstName?.[0] ?? ''}${user.lastName?.[0] ?? ''}`.toUpperCase();
  return combined || (user.username?.[0] ?? '?').toUpperCase();
}

export { userDisplayName };
